export const BrandIcon = ({
  width,
  height,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width || "167"}
    height={height || "63"}
    viewBox="0 0 167 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2491_10409)">
      <path
        d="M48.6618 27.5586H40.7699V51.5786H43.8918V41.5929H48.6618C53.0545 41.5929 55.9713 39.1923 55.9713 34.5944C55.9713 29.756 53.295 27.5586 48.6618 27.5586ZM48.6618 38.7446C48.6618 38.7446 47.6088 38.7197 47.1631 38.7446C44.4536 38.8917 43.8918 41.1783 43.8918 41.1783V30.4069H48.6618C51.166 30.4069 52.8141 31.7108 52.8141 34.5923C52.8141 37.4738 51.2013 38.7425 48.6618 38.7425V38.7446Z"
        fill="white"
      />
      <path
        d="M60.6293 37.7159V34.766H57.5405V51.5802H60.6293V43.0352C60.6293 38.06 62.9283 37.4754 65.3309 37.4754H66.2928V34.4219C63.5813 34.4219 61.7632 35.0044 60.6314 37.7159H60.6293Z"
        fill="white"
      />
      <path
        d="M80.0286 40.1164C80.0286 36.4451 77.5596 34.4219 73.5774 34.4219C69.8377 34.4219 67.093 36.5135 67.093 39.6728H70.215C70.215 38.0248 71.3116 36.9281 73.5774 36.9281C75.8432 36.9281 76.9398 37.9916 76.9398 40.1869V41.4556C69.9745 41.7645 66.5084 43.6862 66.5084 47.2206C66.5084 49.8969 68.5669 51.9222 71.5873 51.9222C73.7826 51.9222 75.8764 50.6183 76.9398 48.8003C76.9046 49.9321 76.9398 50.7904 77.145 51.5802H80.2338C80.0618 50.3799 80.0265 48.3898 80.0265 44.2376V40.1185L80.0286 40.1164ZM76.9419 45.0585C76.9419 47.6663 74.7466 49.416 72.4124 49.416C70.7311 49.416 69.6325 48.5577 69.6325 47.0133C69.6325 44.9196 71.6225 43.6841 76.9419 43.3773V45.0585Z"
        fill="white"
      />
      <path
        d="M93.4202 37.3386C92.8024 36.0347 91.1565 34.4219 88.5486 34.4219C84.498 34.4219 81.7554 37.3386 81.7554 42.8279C81.7554 48.3173 84.4316 51.234 88.5486 51.234C91.0881 51.234 92.734 49.8264 93.4202 48.3504V51.576C93.4202 55.0421 91.8406 56.2776 89.3032 56.2776C86.7658 56.2776 85.4598 55.2826 85.1178 52.9152H82.029C82.3711 56.5533 85.0141 58.7839 89.1311 58.7839C93.7643 58.7839 96.5422 56.0724 96.5422 51.5781V34.7639H93.4202V37.3365V37.3386ZM89.2348 48.7319C86.4901 48.7319 84.8421 46.8786 84.8421 42.83C84.8421 38.7814 86.4901 36.9281 89.2348 36.9281C91.9795 36.9281 93.5923 38.7814 93.5923 42.83C93.5923 46.8786 91.9795 48.7319 89.2348 48.7319Z"
        fill="white"
      />
      <path
        d="M102.504 41.2856C102.504 38.5409 104.013 36.9634 105.694 36.9634C107.376 36.9634 108.51 37.7864 108.51 39.9485V51.5802H111.632V41.2856C111.632 38.5409 113.108 36.9634 114.789 36.9634C116.574 36.9634 117.602 37.7864 117.602 39.9485V51.5802H120.724V39.9133C120.724 36.0347 118.87 34.4219 116.126 34.4219C113.999 34.4219 112.488 35.589 111.151 37.5459C110.533 35.4522 109.092 34.4219 106.998 34.4219C104.905 34.4219 103.36 35.8294 102.504 37.4422V34.766H99.4153V51.5802H102.504V41.2856Z"
        fill="white"
      />
      <path
        d="M133.015 51.5781H136.103C135.931 50.3778 135.896 48.3877 135.896 44.2355V40.1164C135.896 36.4451 133.427 34.4219 129.445 34.4219C125.705 34.4219 122.961 36.5135 122.961 39.6728H126.083C126.083 38.0248 127.181 36.9281 129.445 36.9281C131.709 36.9281 132.807 37.9916 132.807 40.1869V41.4556C125.842 41.7645 122.376 43.6862 122.376 47.2206C122.376 49.8969 124.434 51.9222 127.455 51.9222C129.65 51.9222 131.744 50.6183 132.807 48.8003C132.772 49.9321 132.807 50.7904 133.013 51.5802L133.015 51.5781ZM128.28 49.416C126.599 49.416 125.5 48.5577 125.5 47.0133C125.5 44.9196 127.49 43.6841 132.809 43.3773V45.0585C132.809 47.6663 130.614 49.416 128.28 49.416Z"
        fill="white"
      />
      <path
        d="M139.441 46.9112C139.441 50.342 141.019 51.5775 144.348 51.5775H145.927V49.0381H145.378C142.874 49.0381 142.532 48.524 142.532 45.8809V37.3028H145.93V34.7633H142.532V30.8516L139.443 31.7098V34.7633H136.87V37.3028H139.443V46.9112H139.441Z"
        fill="white"
      />
      <path
        d="M150.836 27.5586H147.132V30.9915H150.836V27.5586Z"
        fill="white"
      />
      <path
        d="M150.528 34.7656H147.439V51.5798H150.528V34.7656Z"
        fill="white"
      />
      <path
        d="M159.703 49.4178C156.958 49.4178 155.517 47.3925 155.517 43.1739C155.517 38.9553 156.958 36.93 159.703 36.93C161.83 36.93 162.964 37.925 163.478 40.3276H166.6C165.878 36.7932 163.923 34.4258 159.703 34.4258C154.763 34.4258 152.428 38.3728 152.428 43.176C152.428 48.2196 154.763 51.9261 159.703 51.9261C163.82 51.9261 166.05 49.4219 166.6 45.8522H163.478C163.136 48.3232 161.933 49.4199 159.703 49.4199V49.4178Z"
        fill="white"
      />
      <path
        d="M8.11795 33.2169C6.6005 33.2086 3.77499 33.3164 1.61699 36.0984C0.371107 37.705 0.0995425 39.324 0.0394252 39.9666L0.0352783 40.4994C0.0477164 41.6105 0.329646 45.3896 3.47855 48.5012C6.21492 51.2065 9.52759 51.619 11.045 51.7123C11.0471 48.6235 11.072 45.7027 11.0948 42.645C11.1197 39.5831 11.1445 36.3057 11.1466 33.2148H8.61961C8.48072 33.2211 8.31281 33.2211 8.11587 33.2211L8.11795 33.2169Z"
        fill="#FFBF00"
      />
      <path
        d="M15.3755 0.0216063C6.90937 0.0216063 0.0228271 6.94338 0.0228271 15.4531V16.9726V35.2234C0.234274 34.8378 0.491329 34.4419 0.798134 34.0459C3.26916 30.8597 6.54244 30.8701 8.12415 30.8784C8.3045 30.8784 8.46205 30.8784 8.59058 30.8742H8.61131L14.8842 30.8721C15.0584 30.8763 15.2159 30.8804 15.3755 30.8804C23.8417 30.8804 30.7283 23.9587 30.7283 15.451C30.7283 6.94339 23.8417 0.0195312 15.3755 0.0195312V0.0216063Z"
        fill="#FFBF00"
      />
      <path
        d="M102.423 58.2622C101.66 58.0508 101.161 57.8621 100.926 57.6942C100.692 57.5284 100.574 57.2962 100.574 56.9956C100.574 56.6763 100.688 56.4234 100.914 56.2348C101.14 56.0461 101.492 55.9529 101.969 55.9529C102.446 55.9529 102.811 56.0648 103.053 56.2887C103.296 56.5126 103.416 56.8049 103.416 57.1676V57.2443H104.575V57.1635C104.575 56.5292 104.339 56.0109 103.866 55.6108C103.393 55.2107 102.761 55.0117 101.969 55.0117C101.177 55.0117 100.551 55.2024 100.095 55.5859C99.6391 55.9694 99.409 56.4587 99.409 57.0536C99.409 57.6486 99.5873 58.086 99.9439 58.4094C100.3 58.7328 100.873 59.0023 101.662 59.2199C102.415 59.4314 102.919 59.6304 103.174 59.817C103.429 60.0035 103.557 60.2564 103.557 60.5757C103.557 60.9157 103.424 61.1893 103.159 61.3966C102.894 61.6039 102.514 61.7096 102.019 61.7096C101.524 61.7096 101.134 61.606 100.858 61.3966C100.582 61.1872 100.441 60.8783 100.441 60.4637V60.3829H99.2722V60.4679C99.2722 61.154 99.5251 61.6889 100.029 62.0724C100.533 62.458 101.196 62.6487 102.019 62.6487C102.842 62.6487 103.499 62.4559 103.986 62.0682C104.473 61.6806 104.72 61.1706 104.72 60.5363C104.716 59.9123 104.527 59.4293 104.15 59.0893C103.773 58.7494 103.198 58.4736 102.421 58.2581L102.423 58.2622Z"
        fill="white"
      />
      <path
        d="M107.724 57.0469C106.984 57.0469 106.387 57.2998 105.929 57.8035C105.473 58.3073 105.243 58.9623 105.243 59.7687V59.9304C105.243 60.741 105.471 61.3981 105.925 61.9019C106.381 62.4056 107.025 62.6585 107.863 62.6585C108.381 62.6585 108.823 62.5507 109.192 62.3351C109.561 62.1195 109.828 61.8749 109.996 61.5992L109.239 61.0499C109.094 61.2447 108.908 61.4147 108.678 61.5598C108.447 61.7049 108.172 61.7754 107.852 61.7754C107.355 61.7754 106.984 61.6034 106.741 61.2592C106.524 60.9504 106.408 60.5668 106.385 60.117H110.05V59.6796C110.05 58.8691 109.847 58.2285 109.44 57.7558C109.034 57.2832 108.46 57.0469 107.722 57.0469H107.724ZM108.935 59.3044H106.412C106.459 58.9706 106.561 58.6783 106.723 58.4358C106.951 58.0917 107.293 57.9196 107.751 57.9196C108.13 57.9196 108.423 58.044 108.628 58.2907C108.833 58.5374 108.935 58.838 108.935 59.1904V59.3065V59.3044Z"
        fill="white"
      />
      <path
        d="M116.764 57.0958C116.414 57.0958 116.099 57.1684 115.817 57.3156C115.535 57.4627 115.29 57.6887 115.081 57.9976H115.056C114.921 57.6887 114.722 57.4607 114.459 57.3156C114.196 57.1705 113.883 57.0958 113.524 57.0958C113.209 57.0958 112.917 57.1622 112.649 57.2969C112.382 57.4317 112.16 57.6161 111.982 57.8504H111.951L111.916 57.1953H110.877V62.5022H112.001V58.8123C112.119 58.5677 112.276 58.3707 112.477 58.2235C112.676 58.0764 112.911 58.0017 113.176 58.0017C113.489 58.0017 113.727 58.0888 113.891 58.2609C114.055 58.4329 114.138 58.7169 114.138 59.1108V62.5022H115.261V58.8123C115.38 58.5697 115.539 58.3749 115.74 58.2256C115.941 58.0764 116.178 58.0017 116.445 58.0017C116.75 58.0017 116.986 58.0888 117.15 58.2609C117.314 58.4329 117.397 58.7148 117.397 59.1046V62.5022H118.526V59.1398C118.526 58.4039 118.369 57.8794 118.052 57.5643C117.734 57.2492 117.305 57.0938 116.762 57.0938L116.764 57.0958Z"
        fill="white"
      />
      <path
        d="M120.251 54.9922C120.029 54.9922 119.859 55.0544 119.741 55.1788C119.623 55.3031 119.565 55.4565 119.565 55.6369C119.565 55.8172 119.623 55.9706 119.741 56.093C119.859 56.2153 120.029 56.2775 120.251 56.2775C120.473 56.2775 120.637 56.2153 120.755 56.093C120.873 55.9706 120.931 55.8172 120.931 55.6369C120.931 55.4565 120.873 55.3031 120.755 55.1788C120.637 55.0544 120.469 54.9922 120.251 54.9922Z"
        fill="white"
      />
      <path
        d="M120.817 57.1953H119.687V62.5022H120.817V57.1953Z"
        fill="white"
      />
      <path
        d="M124.252 57.0469C123.473 57.0469 122.855 57.2977 122.401 57.7973C121.947 58.2969 121.719 58.954 121.719 59.7687V59.9304C121.719 60.7431 121.947 61.4023 122.401 61.9039C122.855 62.4056 123.473 62.6564 124.252 62.6564C124.978 62.6564 125.533 62.4637 125.919 62.076C126.304 61.6904 126.495 61.253 126.495 60.7659V60.7265H125.401V60.7617C125.401 61.0312 125.311 61.2675 125.131 61.4707C124.951 61.6738 124.656 61.7754 124.246 61.7754C123.771 61.7754 123.423 61.6034 123.201 61.2592C122.977 60.9151 122.865 60.4819 122.865 59.9615V59.7439C122.865 59.2235 122.979 58.7903 123.205 58.4462C123.431 58.102 123.779 57.93 124.246 57.93C124.646 57.93 124.938 58.0295 125.125 58.2306C125.311 58.4296 125.405 58.6659 125.405 58.9395V58.9789H126.493V58.9292C126.483 58.442 126.288 58.0067 125.908 57.6232C125.529 57.2397 124.976 57.049 124.25 57.049L124.252 57.0469Z"
        fill="white"
      />
      <path
        d="M129.538 57.0469C128.763 57.0469 128.139 57.2977 127.666 57.7994C127.194 58.301 126.957 58.9582 126.957 59.7667V59.9284C126.957 60.741 127.194 61.4002 127.666 61.9019C128.139 62.4035 128.763 62.6544 129.538 62.6544C130.313 62.6544 130.937 62.4035 131.408 61.9019C131.879 61.4002 132.113 60.741 132.113 59.9284V59.7667C132.113 58.9561 131.879 58.301 131.408 57.7994C130.937 57.2977 130.313 57.0469 129.538 57.0469ZM130.964 59.9595C130.964 60.4901 130.844 60.9234 130.602 61.2592C130.359 61.5951 130.005 61.763 129.538 61.763C129.072 61.763 128.711 61.5951 128.471 61.2592C128.23 60.9234 128.108 60.4901 128.108 59.9595V59.7418C128.108 59.2111 128.23 58.7758 128.473 58.4399C128.715 58.102 129.072 57.9341 129.538 57.9341C130.005 57.9341 130.355 58.102 130.6 58.4399C130.842 58.7778 130.964 59.2111 130.964 59.7418V59.9595Z"
        fill="white"
      />
      <path
        d="M135.67 57.0898C135.339 57.0898 135.034 57.1583 134.758 57.2971C134.482 57.436 134.256 57.6185 134.082 57.8465H134.057L134.018 57.1956H132.979V62.5025H134.103V58.8125C134.221 58.5679 134.387 58.371 134.603 58.2238C134.818 58.0766 135.059 58.002 135.328 58.002C135.652 58.002 135.898 58.0849 136.072 58.2507C136.244 58.4166 136.332 58.6964 136.332 59.0903V62.5025H137.455V59.111C137.455 58.3793 137.291 57.8589 136.966 57.5521C136.64 57.2453 136.207 57.0919 135.67 57.0919V57.0898Z"
        fill="white"
      />
      <path
        d="M142.041 57.7878C141.893 57.5805 141.69 57.4105 141.435 57.2841C141.18 57.1556 140.873 57.0934 140.519 57.0934C139.843 57.0934 139.3 57.3442 138.888 57.8438C138.475 58.3455 138.27 58.984 138.27 59.7634V59.9251C138.27 60.7046 138.473 61.3451 138.879 61.8489C139.286 62.3526 139.833 62.6014 140.523 62.6014C140.88 62.6014 141.193 62.5267 141.462 62.3796C141.732 62.2324 141.931 62.0499 142.055 61.8344H142.086L142.121 62.4998H143.16V54.7695H142.041V57.7878ZM142.034 60.8683C141.937 61.0943 141.779 61.2912 141.564 61.4612C141.346 61.6312 141.083 61.7162 140.77 61.7162C140.31 61.7162 139.97 61.5483 139.75 61.2124C139.53 60.8766 139.42 60.4558 139.42 59.9521V59.7448C139.42 59.241 139.53 58.8202 139.752 58.4844C139.974 58.1485 140.314 57.9806 140.776 57.9806C141.091 57.9806 141.356 58.0656 141.57 58.2356C141.784 58.4056 141.939 58.6005 142.036 58.8223V60.8683H142.034Z"
        fill="white"
      />
      <path
        d="M147.634 60.8853C147.52 61.1237 147.356 61.3185 147.144 61.4699C146.933 61.6212 146.688 61.6958 146.413 61.6958C146.093 61.6958 145.845 61.6108 145.668 61.4408C145.492 61.2709 145.403 60.9848 145.403 60.5826V57.1953H144.279V60.5577C144.279 61.2937 144.441 61.8181 144.767 62.1332C145.09 62.4483 145.519 62.6038 146.054 62.6038C146.39 62.6038 146.697 62.5375 146.97 62.4027C147.244 62.268 147.472 62.0855 147.65 61.8534H147.681L147.716 62.5043H148.755V57.1974H147.631V60.8873L147.634 60.8853Z"
        fill="white"
      />
      <path
        d="M152.159 57.0469C151.379 57.0469 150.762 57.2977 150.308 57.7973C149.854 58.2969 149.626 58.954 149.626 59.7687V59.9304C149.626 60.7431 149.854 61.4023 150.308 61.9039C150.762 62.4056 151.379 62.6564 152.159 62.6564C152.884 62.6564 153.44 62.4637 153.826 62.076C154.211 61.6904 154.402 61.253 154.402 60.7659V60.7265H153.307V60.7617C153.307 61.0312 153.218 61.2675 153.038 61.4707C152.858 61.6738 152.563 61.7754 152.153 61.7754C151.678 61.7754 151.33 61.6034 151.108 61.2592C150.884 60.9151 150.772 60.4819 150.772 59.9615V59.7439C150.772 59.2235 150.886 58.7903 151.112 58.4462C151.338 58.102 151.686 57.93 152.153 57.93C152.553 57.93 152.845 58.0295 153.032 58.2306C153.218 58.4296 153.312 58.6659 153.312 58.9395V58.9789H154.4V58.9292C154.39 58.442 154.195 58.0067 153.815 57.6232C153.436 57.2397 152.882 57.049 152.157 57.049L152.159 57.0469Z"
        fill="white"
      />
      <path
        d="M156.471 55.9062H155.351V57.1957H154.454V58.0373H155.351V61.1012C155.351 61.636 155.478 62.0279 155.733 62.2787C155.988 62.5295 156.326 62.6539 156.753 62.6539C156.921 62.6539 157.076 62.6394 157.217 62.6083C157.358 62.5772 157.47 62.542 157.555 62.5026V61.6298C157.468 61.663 157.381 61.6899 157.296 61.7107C157.211 61.7314 157.122 61.7418 157.03 61.7418C156.846 61.7418 156.707 61.692 156.612 61.5925C156.518 61.493 156.471 61.3272 156.471 61.0908V58.0373H157.559V57.1957H156.471V55.9062Z"
        fill="white"
      />
      <path
        d="M160.426 57.0469C159.651 57.0469 159.027 57.2977 158.554 57.7994C158.082 58.301 157.845 58.9582 157.845 59.7667V59.9284C157.845 60.741 158.082 61.4002 158.554 61.9019C159.027 62.4035 159.651 62.6544 160.426 62.6544C161.201 62.6544 161.825 62.4035 162.296 61.9019C162.767 61.4002 163.001 60.741 163.001 59.9284V59.7667C163.001 58.9561 162.767 58.301 162.296 57.7994C161.825 57.2977 161.201 57.0469 160.426 57.0469ZM161.852 59.9595C161.852 60.4901 161.732 60.9234 161.49 61.2592C161.247 61.5951 160.893 61.763 160.426 61.763C159.96 61.763 159.599 61.5951 159.359 61.2592C159.118 60.9234 158.996 60.4901 158.996 59.9595V59.7418C158.996 59.2111 159.118 58.7758 159.361 58.4399C159.603 58.102 159.96 57.9341 160.426 57.9341C160.893 57.9341 161.243 58.102 161.487 58.4399C161.73 58.7778 161.852 59.2111 161.852 59.7418V59.9595Z"
        fill="white"
      />
      <path
        d="M166.206 57.0469C165.926 57.0469 165.683 57.1277 165.474 57.2873C165.265 57.447 165.099 57.6335 164.974 57.845H164.943L164.904 57.2003H163.865V62.5072H164.989V58.8794C165.086 58.6535 165.235 58.4669 165.437 58.3156C165.638 58.1642 165.876 58.0896 166.152 58.0896C166.239 58.0896 166.318 58.0937 166.388 58.102C166.459 58.1103 166.525 58.1207 166.589 58.1352V57.1215C166.558 57.107 166.504 57.0925 166.425 57.0759C166.347 57.0593 166.272 57.051 166.202 57.051L166.206 57.0469Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2491_10409">
        <rect width="166.67" height="62.6049" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BrandIconPrimary = () => (
  <svg
    width="168"
    height="59"
    viewBox="0 0 168 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_385_4528)">
      <path
        d="M41.4243 51.7553V27.6265H49.3276C53.9535 27.6265 56.6501 29.8332 56.6501 34.684C56.6501 39.3057 53.7253 41.7207 49.3276 41.7207H44.5566V51.7553H41.4243ZM44.5566 30.4994V41.3251C44.5566 41.3251 45.1167 39.0351 47.8341 38.8893C48.2905 38.8685 49.3276 38.8893 49.3276 38.8893C51.8584 38.8893 53.4764 37.6194 53.4764 34.7256C53.4764 31.8318 51.8376 30.5203 49.3276 30.5203H44.5566V30.4994Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M61.2964 34.871V37.8272C62.4373 35.1 64.242 34.5171 66.9594 34.5171V37.5774H66.0052C63.5989 37.5774 61.2964 38.1603 61.2964 43.1568V51.7341H58.2056V34.8502H61.2964V34.871Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M77.829 51.7566C77.6215 50.9654 77.5801 50.1119 77.6215 48.9669C76.5636 50.7989 74.4685 52.1105 72.2697 52.1105C69.2411 52.1105 67.1875 50.0702 67.1875 47.3846C67.1875 43.8455 70.6517 41.9093 77.6215 41.5971V40.3271C77.6215 38.1204 76.4599 37.0586 74.2611 37.0586C72 37.0586 70.9006 38.162 70.9006 39.8067H67.7683C67.7683 36.6422 70.5065 34.5396 74.2611 34.5396C78.2439 34.5396 80.7123 36.5798 80.7123 40.2647V44.4076C80.7123 48.5713 80.7538 50.5699 80.9198 51.7774H77.829V51.7566ZM77.6215 45.2195V43.5124C72.2904 43.8247 70.299 45.053 70.299 47.1556C70.299 48.717 71.3985 49.5706 73.0787 49.5706C75.4227 49.5914 77.6215 47.8218 77.6215 45.2195Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M89.8193 59.0001C85.6913 59.0001 83.0569 56.7517 82.7042 53.1084H85.795C86.1477 55.4818 87.5168 56.481 89.9853 56.481C92.516 56.481 94.1132 55.2319 94.1132 51.7552V48.5075C93.4287 49.9856 91.7692 51.4013 89.2385 51.4013C85.1105 51.4013 82.4346 48.7157 82.4346 42.9489C82.4346 37.432 85.1727 34.4966 89.2385 34.4966C91.8522 34.4966 93.4909 36.1204 94.1132 37.432V34.8505H97.2455V51.7344C97.2455 56.2729 94.4659 59.0001 89.8193 59.0001ZM94.2792 42.9698C94.2792 38.9101 92.6404 37.0365 89.923 37.0365C87.1849 37.0365 85.5254 38.9309 85.5254 42.9698C85.5254 47.0294 87.1641 48.9031 89.923 48.9031C92.6612 48.9031 94.2792 47.0294 94.2792 42.9698Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M118.3 51.7543V40.075C118.3 37.9099 117.263 37.0772 115.479 37.0772C113.798 37.0772 112.326 38.6594 112.326 41.4283V51.7751H109.193V40.0959C109.193 37.9307 108.135 37.098 106.372 37.098C104.692 37.098 103.178 38.6802 103.178 41.4491V51.7959H100.087V34.912H103.178V37.5976C104.028 35.9738 105.584 34.5581 107.679 34.5581C109.774 34.5581 111.206 35.599 111.828 37.7017C113.176 35.7448 114.67 34.5581 116.806 34.5581C119.544 34.5581 121.411 36.182 121.411 40.075V51.7959H118.3V51.7543Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M133.733 51.7566C133.526 50.9654 133.484 50.1119 133.526 48.9669C132.468 50.7989 130.373 52.1105 128.174 52.1105C125.145 52.1105 123.092 50.0702 123.092 47.3846C123.092 43.8455 126.556 41.9093 133.526 41.5971V40.3271C133.526 38.1204 132.364 37.0586 130.165 37.0586C127.904 37.0586 126.805 38.162 126.805 39.8067H123.673C123.673 36.6422 126.411 34.5396 130.165 34.5396C134.148 34.5396 136.617 36.5798 136.617 40.2647V44.4076C136.617 48.5713 136.658 50.5699 136.824 51.7774H133.733V51.7566ZM133.526 45.2195V43.5124C128.195 43.8247 126.203 45.053 126.203 47.1556C126.203 48.717 127.303 49.5706 128.983 49.5706C131.327 49.5914 133.526 47.8218 133.526 45.2195Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M140.164 37.4113H137.592V34.8714H140.164V31.8111L143.255 30.9575V34.8922H146.657V37.4321H143.255V46.051C143.255 48.695 143.607 49.2155 146.097 49.2155H146.657V51.7761H145.08C141.741 51.7761 140.164 50.527 140.164 47.092V37.4113Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M147.86 31.0824H151.573V27.6265H147.86V31.0824ZM148.171 51.7553H151.262V34.8713H148.171V51.7553Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M164.206 40.4504C163.687 38.0354 162.567 37.0361 160.43 37.0361C157.692 37.0361 156.24 39.0764 156.24 43.3025C156.24 47.5287 157.692 49.569 160.43 49.569C162.671 49.569 163.874 48.4656 164.206 45.9881H167.338C166.778 49.569 164.558 52.088 160.43 52.088C155.493 52.088 153.149 48.3615 153.149 43.3025C153.149 38.4726 155.493 34.5171 160.43 34.5171C164.662 34.5171 166.612 36.8904 167.338 40.4504H164.206Z"
        fill="var(--PRIMARY)"
      />
      <path
        d="M8.75261 33.3086C7.23832 33.3086 4.41719 33.4127 2.23911 36.2024C0.994495 37.8262 0.724829 39.4501 0.662598 40.0955V40.6368C0.683341 41.761 0.953008 45.5499 4.10604 48.6727C6.8442 51.3792 10.1632 51.7955 11.6775 51.8996C11.6775 48.7977 11.6982 45.8622 11.7189 42.8019C11.7397 39.7207 11.7604 36.4314 11.7604 33.3294H9.22971C9.12599 33.3086 8.9393 33.3086 8.75261 33.3086Z"
        fill="#FCBE0C"
      />
      <path
        d="M16.0129 30.9786C24.4763 30.9786 31.3839 24.0252 31.3839 15.4895C31.3839 6.95391 24.497 0.000488281 16.0129 0.000488281C7.52874 0.000488281 0.662598 6.93309 0.662598 15.4687V15.5104V16.9885V35.3089C0.870034 34.9133 1.1397 34.5178 1.43011 34.1222C3.8986 30.9161 7.1761 30.937 8.75261 30.937C8.9393 30.937 9.08451 30.937 9.22971 30.937H9.25046H15.5358C15.7017 30.9578 15.8469 30.9786 16.0129 30.9786Z"
        fill="#FCBE0C"
      />
    </g>
    <defs>
      <clipPath id="clip0_385_4528">
        <rect
          width="166.675"
          height="59"
          fill="white"
          transform="translate(0.662598)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BrandIconSmall = () => (
  <svg
    width="31"
    height="52"
    viewBox="0 0 31 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.09001 33.3585C6.57573 33.3585 3.75459 33.4626 1.57651 36.2523C0.331898 37.8761 0.0622309 39.5 0 40.1453V40.6866C0.0207436 41.8108 0.29041 45.5998 3.44344 48.7226C6.1816 51.429 9.50058 51.8454 11.0149 51.9495C11.0149 48.8475 11.0356 45.9121 11.0563 42.8518C11.0771 39.7706 11.0978 36.4813 11.0978 33.3793H8.56711C8.4634 33.3585 8.2767 33.3585 8.09001 33.3585Z"
      fill="#FCBE0C"
    />
    <path
      d="M15.3503 31.0279C23.8137 31.0279 30.7213 24.0745 30.7213 15.5389C30.7213 7.00323 23.8344 0.0498047 15.3503 0.0498047C6.86614 0.0498047 0 6.98241 0 15.518V35.3582C0.207436 34.9626 0.477103 34.5671 0.767513 34.1715C3.236 30.9655 6.5135 30.9863 8.09001 30.9863C8.27671 30.9863 8.42191 30.9863 8.56712 30.9863H14.8732C15.0391 31.0071 15.1843 31.0279 15.3503 31.0279Z"
      fill="#FCBE0C"
    />
  </svg>
);

export const ProductIcon = () => (
  <svg
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.0134 24.5968L27.7063 22.9893L19.456 26.0528C19.001 26.2044 18.4854 26.3258 18.0001 26.3258C17.4845 26.3258 16.9992 26.2348 16.5442 26.0528L8.29394 22.9893L3.98683 24.5968C3.47119 24.7788 3.47119 25.5068 3.98683 25.7191L17.3025 30.6329C17.7574 30.7845 18.2428 30.7845 18.6977 30.6329L32.0134 25.7191C32.529 25.5068 32.529 24.7788 32.0134 24.5968Z"
      fill="var(--PRIMARY)"
    />
    <path
      d="M32.0134 17.9538L27.7063 16.3462L19.456 19.3794C19.001 19.5614 18.4854 19.6524 18.0001 19.6524C17.4845 19.6524 16.9992 19.5614 16.5442 19.3794L8.29394 16.3462L3.98683 17.9538C3.47119 18.1358 3.47119 18.8637 3.98683 19.076L17.3025 23.9595C17.7574 24.1415 18.2428 24.1415 18.6977 23.9595L32.0134 19.0457C32.529 18.8637 32.529 18.1358 32.0134 17.9538Z"
      fill="var(--PRIMARY)"
    />
    <path
      d="M3.98683 12.4032L17.3025 17.3169C17.7574 17.4686 18.2428 17.4686 18.6977 17.3169L32.0134 12.4032C32.529 12.2212 32.529 11.4629 32.0134 11.2809L18.6977 6.36716C18.2428 6.2155 17.7574 6.2155 17.3025 6.36716L3.98683 11.2809C3.47119 11.4629 3.47119 12.2212 3.98683 12.4032Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export const MenuToggleIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="white" />
    <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="var(--PRIMARY)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1658 9.23431C15.4782 9.54673 15.4782 10.0533 15.1658 10.3657L12.5315 13L15.1658 15.6343C15.4782 15.9467 15.4782 16.4533 15.1658 16.7657C14.8534 17.0781 14.3468 17.0781 14.0344 16.7657L10.8344 13.5657C10.522 13.2533 10.522 12.7467 10.8344 12.4343L14.0344 9.23431C14.3468 8.9219 14.8534 8.9219 15.1658 9.23431Z"
      fill="#081021"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7365 18.4796L16.2229 14.9646C17.2764 13.5918 17.7682 11.8697 17.5987 10.1476C17.4291 8.42548 16.6108 6.83237 15.3098 5.6914C14.0087 4.55043 12.3224 3.94705 10.5928 4.00365C8.86322 4.06025 7.21993 4.7726 5.99629 5.99619C4.77264 7.21978 4.06026 8.86299 4.00365 10.5925C3.94705 12.322 4.55046 14.0083 5.69148 15.3092C6.8325 16.6102 8.42569 17.4285 10.1479 17.598C11.87 17.7676 13.5922 17.2758 14.9651 16.2223L18.4817 19.7395C18.5643 19.8221 18.6623 19.8876 18.7703 19.9323C18.8782 19.977 18.9938 20 19.1106 20C19.2274 20 19.3431 19.977 19.451 19.9323C19.5589 19.8876 19.6569 19.8221 19.7395 19.7395C19.8221 19.6569 19.8876 19.5589 19.9323 19.451C19.977 19.3431 20 19.2274 20 19.1106C20 18.9939 19.977 18.8782 19.9323 18.7703C19.8876 18.6624 19.8221 18.5644 19.7395 18.4818L19.7365 18.4796ZM5.79063 10.8215C5.79063 9.82645 6.0857 8.85377 6.63853 8.02644C7.19136 7.19911 7.97712 6.55428 8.89644 6.1735C9.81577 5.79272 10.8274 5.69309 11.8033 5.88721C12.7793 6.08133 13.6757 6.56048 14.3793 7.26407C15.083 7.96766 15.5621 8.86408 15.7563 9.83998C15.9504 10.8159 15.8508 11.8274 15.47 12.7467C15.0892 13.666 14.4443 14.4517 13.6169 15.0045C12.7896 15.5573 11.8169 15.8524 10.8218 15.8524C9.48786 15.851 8.20896 15.3205 7.26573 14.3774C6.32251 13.4342 5.792 12.1553 5.79063 10.8215Z"
      fill="#9C9C9E"
    />
  </svg>
);

export const PasswordVisibleIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 10.1C10.6444 10.1 9.54545 11.1745 9.54545 12.5C9.54545 13.8255 10.6444 14.9 12 14.9C13.3556 14.9 14.4545 13.8255 14.4545 12.5C14.4545 11.1745 13.3556 10.1 12 10.1ZM12 16.5C9.74065 16.5 7.90909 14.7091 7.90909 12.5C7.90909 10.2909 9.74065 8.5 12 8.5C14.2593 8.5 16.0909 10.2909 16.0909 12.5C16.0909 14.7091 14.2593 16.5 12 16.5ZM12 6.5C7.90909 6.5 4.41545 8.988 3 12.5C4.41545 16.012 7.90909 18.5 12 18.5C16.0909 18.5 19.5845 16.012 21 12.5C19.5845 8.988 16.0909 6.5 12 6.5Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export const PasswordHiddenIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4545 7.71368C11.4545 7.67158 11.4545 7.62105 11.4545 7.57895C11.4545 6.24988 10.3569 5.20001 9.08838 5.17877C9.0393 5.17795 8.99838 5.17877 8.94929 5.17877L11.4545 7.71368ZM6.61091 7.03158C6.57 7.20842 6.54167 7.3853 6.54545 7.57895C6.57229 8.95103 7.62826 9.90331 8.8797 9.97671C9.05939 9.98725 9.26479 9.98252 9.43661 9.94041L10.7158 11.2227C10.0972 11.4719 9.64636 11.5754 9 11.5754C6.77956 11.5754 4.90909 9.80952 4.90909 7.57895C4.90909 6.91368 5.07101 6.2949 5.36626 5.74497L6.61091 7.03158ZM0.818182 1.06947L2.68364 2.98947L3.17308 3.4905C1.78559 4.55433 0.669788 5.9092 0 7.57895C1.45801 11.2411 5.10279 13.5804 9 13.5804C10.2682 13.5804 11.3074 13.3517 12.3838 12.9861L12.9355 13.5411L15.3245 16L16.3636 14.9305L1.85727 0L0.818182 1.06947ZM9 3.56998C11.2453 3.6058 13.0404 5.27971 13.0909 7.57895C13.1027 8.1178 12.9845 8.64 12.7964 9.11158L15.101 11.4719C16.3636 10.4189 17.3748 9.13473 18 7.57895C16.6791 4.24758 13.3533 1.68368 9.23337 1.57613C8.08849 1.54625 6.99372 1.72276 5.90174 2.06994L7.50273 3.86472C7.96909 3.67946 8.46818 3.56998 9 3.56998Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export const CopyIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3332 5.66669V3.33335C12.3332 2.39993 12.3332 1.93322 12.1515 1.5767C11.9917 1.2631 11.7368 1.00813 11.4232 0.848343C11.0666 0.666687 10.5999 0.666687 9.6665 0.666687H3.33317C2.39975 0.666687 1.93304 0.666687 1.57652 0.848343C1.26292 1.00813 1.00795 1.2631 0.84816 1.5767C0.666504 1.93322 0.666504 2.39993 0.666504 3.33335V9.66669C0.666504 10.6001 0.666504 11.0668 0.84816 11.4233C1.00795 11.7369 1.26292 11.9919 1.57652 12.1517C1.93304 12.3334 2.39975 12.3334 3.33317 12.3334H5.6665M8.33317 17.3334H14.6665C15.5999 17.3334 16.0666 17.3334 16.4232 17.1517C16.7368 16.9919 16.9917 16.7369 17.1515 16.4233C17.3332 16.0668 17.3332 15.6001 17.3332 14.6667V8.33335C17.3332 7.39993 17.3332 6.93322 17.1515 6.5767C16.9917 6.2631 16.7368 6.00813 16.4232 5.84834C16.0666 5.66669 15.5999 5.66669 14.6665 5.66669H8.33317C7.39975 5.66669 6.93304 5.66669 6.57652 5.84834C6.26292 6.00813 6.00795 6.2631 5.84816 6.5767C5.6665 6.93322 5.6665 7.39993 5.6665 8.33335V14.6667C5.6665 15.6001 5.6665 16.0668 5.84816 16.4233C6.00795 16.7369 6.26292 16.9919 6.57652 17.1517C6.93304 17.3334 7.39975 17.3334 8.33317 17.3334Z"
      stroke="var(--PRIMARY)"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownArrowWhite = () => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49984 0.916687V9.08335M5.49984 9.08335L9.58317 5.00002M5.49984 9.08335L1.4165 5.00002"
      stroke="white"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowWhite = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8.5H15M15 8.5L8 1.5M15 8.5L8 15.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6L1 1M6 6L11 11M6 6L11 1M6 6L1 11"
      stroke="#627078"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SortIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99967 1.3335V10.6668M5.99967 10.6668L10.6663 6.00016M5.99967 10.6668L1.33301 6.00016"
      stroke="var(--PRIMARY)"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExpiredIcon = () => (
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="160" height="160" rx="80" fill="#F6F6F7" />
    <path
      d="M104.11 16.2707C104.43 16.1576 104.882 16.1337 105.164 16.2151C106.065 16.4754 106.634 17.5321 106.363 18.4435C106.222 18.9173 98.2021 28.8928 97.7934 29.1024C97.6204 29.1913 97.2188 29.2614 96.9008 29.2585C96.4165 29.2541 96.2344 29.1679 95.7782 28.727C95.2783 28.2441 95.2336 28.1476 95.2338 27.5527C95.2341 27.1962 95.3154 26.7877 95.4147 26.6449C95.5139 26.5021 97.3846 24.154 99.5718 21.4269C103.472 16.5642 103.559 16.4649 104.11 16.2707Z"
      fill="#B3B3B3"
    />
    <path
      d="M99.7481 36.2123C99.2984 35.2974 99.7602 34.0869 100.671 33.7932L114.138 32.4307C115.455 32.8391 115.734 34.7473 114.591 35.5243C114.259 35.7499 112.694 35.9765 107.617 36.5339L100.53 36.9781C100.101 36.7599 99.94 36.6026 99.7481 36.2123Z"
      fill="#B3B3B3"
    />
    <path
      d="M85.7588 11.484C86.312 10.9996 87.104 10.8508 87.6805 11.1229C88.2125 11.3737 88.3874 11.5555 88.5708 12.048C88.7725 12.5893 90.0517 24.2577 90.0039 25.1198C89.9698 25.7333 89.8982 25.8958 89.5138 26.2324C88.644 26.9939 87.3534 26.8536 86.8118 25.9386C86.5439 25.4861 85.1621 13.5428 85.2585 12.5143C85.3075 11.9933 85.4039 11.7947 85.7588 11.484Z"
      fill="#B3B3B3"
    />
    <g clipPath="url(#clip0_628_4762)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.1443 64.2706L33.2153 66.5853L35.519 65.5194L37.8226 64.4535L38.319 65.3011C42.413 72.2934 45.3003 75.6796 50.1649 79.1934C53.255 81.4254 55.8367 82.5614 65.4978 85.9402C70.0682 87.5386 71.2777 88.3913 72.3923 90.8001C73.5069 93.209 73.3739 94.6828 71.6337 99.2012C67.9554 108.752 67.1501 111.455 66.8511 115.256C66.3804 121.238 67.0924 125.631 69.772 133.277L70.0968 134.205L67.7931 135.27L65.4895 136.336L66.5608 138.652L67.6319 140.967L97.7442 126.986L127.856 113.006L126.828 110.671L125.8 108.337L123.437 109.486L121.074 110.635L120.574 109.78C116.468 102.772 113.59 99.3964 108.723 95.8811C105.633 93.649 103.052 92.5131 93.3905 89.1343C88.82 87.5358 87.6105 86.6832 86.4959 84.2743C85.3813 81.8654 85.5144 80.3916 87.2545 75.8732C90.9329 66.3222 91.7382 63.6191 92.0371 59.8189C92.5076 53.838 91.7947 49.4378 89.1176 41.8012L88.794 40.8783L91.1172 39.7518L93.4402 38.6253L92.4297 36.3293L91.4191 34.0334L61.2463 47.9946L31.0732 61.9558L32.1443 64.2706ZM32.2417 64.3192C32.8309 65.5922 33.0864 66.0814 32.8092 65.4063C32.5321 64.7313 32.05 63.6897 31.7378 63.0917C31.4256 62.4938 31.6525 63.0461 32.2417 64.3192ZM43.4507 63.8465C44.6142 65.9868 46.7061 68.9129 48.3244 70.664L49.6484 72.0965L68.3052 63.4639L86.9621 54.8312L86.7272 52.8947C86.4401 50.5277 85.5639 47.0392 84.6856 44.7669L84.031 43.0726L63.307 52.6617L42.5831 62.2508L43.4507 63.8465ZM77.8064 90.3788C78.1033 91.2136 78.2903 93.623 78.1591 94.9246C77.9832 96.6697 77.5571 98.1957 76.4303 101.116C73.7396 108.089 73.2861 109.33 72.8928 110.803C72.3227 112.936 71.9786 115.184 71.912 117.209C71.8403 119.386 71.8816 119.961 72.0936 119.742C72.1822 119.651 74.8376 116.777 77.9946 113.356C81.1516 109.934 84.0063 106.902 84.3385 106.618C84.6706 106.334 84.9746 106.032 85.0137 105.948C85.0531 105.864 83.4137 102.231 81.3708 97.876C79.3277 93.5205 77.7238 90.1468 77.8064 90.3788ZM86.1224 95.7529L89.8466 103.743L91.0886 103.593C91.7717 103.51 95.9729 103.297 100.425 103.12C104.877 102.942 108.623 102.79 108.75 102.782C109.054 102.761 108.642 102.358 106.937 101.003C105.35 99.7431 103.414 98.5505 101.418 97.6039C100.042 96.9505 98.8015 96.4924 91.7449 94.0296C90.4079 93.563 88.7945 92.9373 88.1597 92.6392C86.0217 91.6352 84.0868 90.075 82.8073 88.323C82.5823 88.0149 84.0741 91.3584 86.1224 95.7529ZM66.6226 138.622C67.2313 139.938 67.504 140.465 67.2286 139.794C66.9533 139.123 66.4552 138.046 66.1218 137.402C65.7887 136.758 66.0139 137.307 66.6226 138.622Z"
        fill="url(#paint0_linear_628_4762)"
      />
    </g>
    <path
      d="M111.834 105.219L116.814 109.834L128.167 98.1675"
      stroke="white"
      strokeWidth="3.07984"
      strokeLinecap="square"
    />
    <circle cx="120" cy="104" r="17.5" fill="#B3B3B3" />
    <path
      d="M118.25 109.25L116.5 93.5H123.5L121.75 109.25H118.25Z"
      fill="white"
    />
    <path
      d="M122.625 113.625C122.625 115.075 121.45 116.25 120 116.25C118.55 116.25 117.375 115.075 117.375 113.625C117.375 112.175 118.55 111 120 111C121.45 111 122.625 112.175 122.625 113.625Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_628_4762"
        x1="48.7106"
        y1="20.9027"
        x2="97.8048"
        y2="127.005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1C1C1" />
        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0.53" />
      </linearGradient>
      <clipPath id="clip0_628_4762">
        <rect
          width="66.6538"
          height="87.058"
          fill="white"
          transform="translate(31 61.99) rotate(-24.8302)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RightArrowDark = () => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.5 7.75V0.25L4.25 4L0.5 7.75Z" fill="#1D1B20" />
  </svg>
);

export const RightArrow = () => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.646447 0.146447C0.451184 0.341709 0.451184 0.658291 0.646447 0.853553L3.79289 4L0.646447 7.14645C0.451185 7.34171 0.451185 7.65829 0.646447 7.85355C0.841709 8.04882 1.15829 8.04882 1.35355 7.85355L4.85355 4.35355C5.04882 4.15829 5.04882 3.84171 4.85355 3.64645L1.35355 0.146447C1.15829 -0.0488155 0.841709 -0.0488155 0.646447 0.146447Z"
      fill="#343434"
    />
  </svg>
);

export const ProductType = () => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.74226 13.1298C1.74226 13.4258 1.96299 13.6659 2.23502 13.6659L15.6177 13.6668C15.7489 13.6668 15.8735 13.611 15.9663 13.51C16.0584 13.4099 16.1105 13.2734 16.1105 13.1316V4.56353L1.74226 4.56265V13.1298ZM0.666992 0.333496H7.81577V2.48089H8.26966V0.333496H9.91357V2.48089H10.4237V0.333496H17.3337V3.78306H0.666992V0.333496Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export const PlatformType = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0416 0.75H1.20822V7.16667H16.7916V3.5C16.7916 1.98122 15.5603 0.75 14.0416 0.75ZM9.91689 7.16674H8.08356V9H1.66644V9.91669V10.8333V13.5833H0.75V17.25H4.41667V13.5833H3.49978V10.8333H8.08356V13.5833H7.16661V17.25H10.8333V13.5833H9.91689V10.8333H14.4997V13.5833H13.5832V17.25H17.2499V13.5833H16.333V10.8333H16.3331V9H9.91689V7.16674Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export const FolderIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.58747 0.709961H3.49141C2.58413 0.709961 2.13049 0.709961 1.78395 0.88653C1.47913 1.04185 1.2313 1.28967 1.07598 1.5945C0.899414 1.94103 0.899414 2.39468 0.899414 3.30196V3.94996V11.402C0.899414 12.7629 0.899414 13.4434 1.16427 13.9632C1.39724 14.4204 1.76898 14.7921 2.22622 15.0251C2.74602 15.29 3.42649 15.29 4.78741 15.29H13.2114C14.5723 15.29 15.2528 15.29 15.7726 15.0251C16.2298 14.7921 16.6016 14.4204 16.8346 13.9632C17.0994 13.4434 17.0994 12.7629 17.0994 11.402V7.83796C17.0994 6.47703 17.0994 5.79657 16.8346 5.27676C16.6016 4.81953 16.2298 4.44779 15.7726 4.21482C15.2528 3.94996 14.5723 3.94996 13.2114 3.94996H9.80941L8.90583 2.14278C8.64577 1.62267 8.51573 1.3626 8.32174 1.1726C8.15019 1.00458 7.94344 0.8768 7.71643 0.798502C7.45974 0.709961 7.16898 0.709961 6.58747 0.709961Z"
      fill="var(--PRIMARY)"
      fillOpacity="0.75"
    />
  </svg>
);

export const VerticalDots = () => (
  <svg
    width="4"
    height="13"
    viewBox="0 0 4 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99967 7.16699C2.36786 7.16699 2.66634 6.86852 2.66634 6.50033C2.66634 6.13214 2.36786 5.83366 1.99967 5.83366C1.63148 5.83366 1.33301 6.13214 1.33301 6.50033C1.33301 6.86852 1.63148 7.16699 1.99967 7.16699Z"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99967 2.50033C2.36786 2.50033 2.66634 2.20185 2.66634 1.83366C2.66634 1.46547 2.36786 1.16699 1.99967 1.16699C1.63148 1.16699 1.33301 1.46547 1.33301 1.83366C1.33301 2.20185 1.63148 2.50033 1.99967 2.50033Z"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99967 11.8337C2.36786 11.8337 2.66634 11.5352 2.66634 11.167C2.66634 10.7988 2.36786 10.5003 1.99967 10.5003C1.63148 10.5003 1.33301 10.7988 1.33301 11.167C1.33301 11.5352 1.63148 11.8337 1.99967 11.8337Z"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadArrow = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4001 11.3996H0.600098M9.6001 5.39961L6.0001 8.99961M6.0001 8.99961L2.4001 5.39961M6.0001 8.99961V0.599609"
      stroke="#153050"
      strokeWidth="1.002"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackArrow = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.02051 8.3335L8.68717 13.0002L7.49967 14.1668L0.833008 7.50016L7.49967 0.833496L8.68717 2.00016L4.02051 6.66683H14.1663V8.3335H4.02051Z"
      fill="var(--PRIMARY)"
    />
  </svg>
);

export const FileUploadWarning = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM8.35742 4.5H9.64314V5.78571H8.35742V4.5ZM8.3591 13.5001V7.07153H9.64481V13.5001H8.3591Z"
      fill="#2B0606"
    />
  </svg>
);

export const FileUploadLabelIcon = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1779 0.265489C9.70979 0.256024 9.25803 0.437823 8.92693 0.768915L0.240442 9.45536C-0.0801455 9.77595 -0.0801486 10.2957 0.24044 10.6163L6.88842 17.2643C7.438 17.8139 8.32905 17.8139 8.87863 17.2643L17.1637 8.97922C17.487 8.65593 17.6683 8.21723 17.6675 7.76002L17.6568 1.56395C17.6557 0.92629 17.1453 0.406359 16.5078 0.393469L10.1779 0.265489ZM12.6338 5.29066C13.0688 5.72575 13.7743 5.72575 14.2093 5.29066C14.6444 4.85558 14.6444 4.15017 14.2093 3.71509C13.7743 3.28 13.0688 3.28 12.6338 3.71509C12.1987 4.15017 12.1987 4.85558 12.6338 5.29066Z"
      fill="#20334D"
    />
    <path
      d="M11.6385 17.3695L19.3538 9.65425C19.6548 9.35319 19.815 8.93603 19.7989 8.49491L19.5808 2.51683C19.5583 1.90161 19.0485 1.38288 18.433 1.34906L18.3131 8.14174C18.3044 8.63512 18.1017 9.10521 17.7489 9.45021L9.71847 17.3027C10.2671 17.8514 11.1268 17.8812 11.6385 17.3695Z"
      fill="#20334D"
    />
  </svg>
);

export const ToastSuccessIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#303746" />
    <mask
      id="mask0_785_4527"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="4"
      width="24"
      height="24"
    >
      <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_785_4527)">
      <path
        d="M14.6 20.6L21.65 13.55L20.25 12.15L14.6 17.8L11.75 14.95L10.35 16.35L14.6 20.6ZM16 26C14.6167 26 13.3167 25.7373 12.1 25.212C10.8833 24.6873 9.825 23.975 8.925 23.075C8.025 22.175 7.31267 21.1167 6.788 19.9C6.26267 18.6833 6 17.3833 6 16C6 14.6167 6.26267 13.3167 6.788 12.1C7.31267 10.8833 8.025 9.825 8.925 8.925C9.825 8.025 10.8833 7.31233 12.1 6.787C13.3167 6.26233 14.6167 6 16 6C17.3833 6 18.6833 6.26233 19.9 6.787C21.1167 7.31233 22.175 8.025 23.075 8.925C23.975 9.825 24.6873 10.8833 25.212 12.1C25.7373 13.3167 26 14.6167 26 16C26 17.3833 25.7373 18.6833 25.212 19.9C24.6873 21.1167 23.975 22.175 23.075 23.075C22.175 23.975 21.1167 24.6873 19.9 25.212C18.6833 25.7373 17.3833 26 16 26Z"
        fill="#00DF80"
      />
    </g>
  </svg>
);

export const ToastCloseIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6663 10.6673L1.33301 1.33398"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6663 1.33398L1.33301 10.6673"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ToastInfoIcon = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="32" height="32" rx="16" fill="#303746" />
    <g clipPath="url(#clip0_2784_23552)">
      <path
        d="M16 6.5C10.48 6.5 6 10.98 6 16.5C6 22.02 10.48 26.5 16 26.5C21.52 26.5 26 22.02 26 16.5C26 10.98 21.52 6.5 16 6.5ZM17 21.5H15V19.5H17V21.5ZM17 17.5H15V11.5H17V17.5Z"
        fill="#FFD21E"
      />
    </g>
    <defs>
      <clipPath id="clip0_2784_23552">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(4 4.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const YellowDot = () => (
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8.5C2.9 8.5 1.95833 8.10833 1.175 7.325C0.391667 6.54167 0 5.6 0 4.5C0 3.4 0.391667 2.45833 1.175 1.675C1.95833 0.891667 2.9 0.5 4 0.5C5.1 0.5 6.04167 0.891667 6.825 1.675C7.60833 2.45833 8 3.4 8 4.5C8 5.6 7.60833 6.54167 6.825 7.325C6.04167 8.10833 5.1 8.5 4 8.5Z"
      fill="#FFBF00"
    />
  </svg>
);

export const DropdownIconWhite = () => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.5L6 1.5L11 6.5"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Clock = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2.5V5.5L8 6.5M11 5.5C11 8.26142 8.76142 10.5 6 10.5C3.23858 10.5 1 8.26142 1 5.5C1 2.73858 3.23858 0.5 6 0.5C8.76142 0.5 11 2.73858 11 5.5Z"
      stroke="#84329B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
